(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review"] && !Shopify.designMode) return;
  try {
    
(function(){
  function imagesLoaded(container, cb){
    var imgs = Array.from(container.querySelectorAll('img'));
    if(!imgs.length) return cb();
    var count = imgs.length;
    imgs.forEach(function(img){
      if(img.complete) {
        if(--count === 0) cb();
      } else {
        img.addEventListener('load', function(){ if(--count === 0) cb(); });
        img.addEventListener('error', function(){ if(--count === 0) cb(); });
      }
    });
  }

  function initCarousel(wrapper){
    var track = wrapper.querySelector('.carousel-track');
    if(!track) return;
    var dotsContainer = wrapper.querySelector('.carousel-dots');
    var btnPrev = wrapper.querySelector('[data-action="prev"], .carousel-btn.prev');
    var btnNext = wrapper.querySelector('[data-action="next"], .carousel-btn.next');

    function scrollBy(amount){ track.scrollBy({ left: amount, behavior: 'smooth' }); }

    // click arrows
    btnPrev && btnPrev.addEventListener('click', function(){ scrollBy(- (track.offsetWidth * 0.9)); });
    btnNext && btnNext.addEventListener('click', function(){ scrollBy(  (track.offsetWidth * 0.9)); });

    // keyboard support
    wrapper.addEventListener('keydown', function(e){
      if(e.key === 'ArrowLeft') btnPrev && btnPrev.click();
      if(e.key === 'ArrowRight') btnNext && btnNext.click();
    });

    function buildDots(pages){
      if(!dotsContainer) return;
      if(dotsContainer.children.length === pages) return;
      dotsContainer.innerHTML = '';
      for(var i=0;i<pages;i++){
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'carousel-dot' + (i===0 ? ' is-active' : '');
        (function(pageIndex){
          d.addEventListener('click', function(){
            track.scrollTo({ left: pageIndex * track.clientWidth, behavior: 'smooth' });
          });
        })(i);
        dotsContainer.appendChild(d);
      }
    }

    function updatePager(){
      // pages calculation
      var pages = 1;
      try { pages = Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth)); } catch(e){ pages = 1; }

      buildDots(pages);

      // update active dot index
      if(dotsContainer && dotsContainer.children.length){
        var currentPage = Math.round(track.scrollLeft / track.clientWidth);
        currentPage = Math.max(0, Math.min(dotsContainer.children.length - 1, currentPage));
        Array.from(dotsContainer.children).forEach(function(el, idx){
          el.classList.toggle('is-active', idx === currentPage);
        });
      }

      // arrows visibility: hide if no overflow
      if(track.scrollWidth > track.clientWidth + 2){
        btnPrev && (btnPrev.style.visibility = '');
        btnNext && (btnNext.style.visibility = '');
      } else {
        btnPrev && (btnPrev.style.visibility = 'hidden');
        btnNext && (btnNext.style.visibility = 'hidden');
      }
    }

    // rAF scroll throttle
    var raf = null;
    track.addEventListener('scroll', function(){
      if(raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updatePager);
    });

    // autoplay reading from data attribute
    var autoplayEnabled = wrapper.dataset.autoplay === 'true';
    var autoplayDelay = 4000;
    var autoplayTimer = null;
    function startAutoplay(){
      if(!autoplayEnabled || autoplayTimer) return;
      autoplayTimer = setInterval(function(){
        if(track.scrollWidth <= track.clientWidth + 2) return;
        track.scrollBy({ left: track.offsetWidth * 0.9, behavior: 'smooth' });
      }, autoplayDelay);
    }
    function stopAutoplay(){ if(autoplayTimer){ clearInterval(autoplayTimer); autoplayTimer = null; } }

    wrapper.addEventListener('mouseenter', stopAutoplay);
    wrapper.addEventListener('mouseleave', startAutoplay);
    wrapper.addEventListener('focusin', stopAutoplay);
    wrapper.addEventListener('focusout', startAutoplay);

    imagesLoaded(track, function(){
      updatePager();
      startAutoplay();
      setTimeout(updatePager, 240);
    });

    var mo = new MutationObserver(function(){ setTimeout(updatePager, 120); });
    mo.observe(track, { childList: true, subtree: true, attributes: true });

    window.addEventListener('resize', updatePager);

    // initial
    updatePager();
  }

  document.querySelectorAll('.carousel-wrap[data-reviews-id]').forEach(initCarousel);
})();

  } catch(e) { console.error(e); }
})();
})();
